import { render, staticRenderFns } from "./importMaterial.vue?vue&type=template&id=189aa052&scoped=true&"
import script from "./importMaterial.vue?vue&type=script&lang=js&"
export * from "./importMaterial.vue?vue&type=script&lang=js&"
import style0 from "./importMaterial.vue?vue&type=style&index=0&id=189aa052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aa052",
  null
  
)

export default component.exports